import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { ApiService }                 from '../../app-lite/api/api.service';
import { AzureSsoService }            from '../../app-lite/azure-sso/azure-sso.service';
import { SessionService }             from '../../app-lite/sessions/session.service';
import { STATUSCODES }                from '../../app-lite/api/api.status-codes.constant';
import { SubscriptionService }        from '../../app-lite/subscriptions/subscription.service';
import { TwoFactorAuthSettingsModel } from '../two-factor-auth/models/two-factor-auth.settings';
import { UserModel }                  from '../../app-lite/users/models/user';

export class LoginServiceAjs {
  private _STATUSCODES = STATUSCODES;

  constructor (
    private $q             : ng.IQService,
    private $state         : ng.ui.IStateService,
    private $window        : ng.IWindowService,
    private azureSsoApi    : AzureSsoService,
    private sessionObjAPI  : SessionService,
    private subscriptionApi: SubscriptionService,
    private workshopAPI    : ApiService
  ) {}

  login ( user : UserModel ) : Promise<any> {
    return this.workshopAPI.post('/sessions/workshop', user, null, null, {
      verbose: true
    })
    .catch(( response : HttpErrorResponse ) => {
      return this.azureSsoApi.isSsoRequiredForLogin(response)
        ? this.azureSsoApi.getSessionUrl(user)
          .then(url => {
            this.$window.location.assign(url);

            return this.$q.reject(response.error);
          })
        : this.$q.reject(response.error);
    })
    .then(( response : HttpResponse<any> ) => response.body)
    .then(( session : any ) => this.handleSession(session, user));
  }

  loginWithTwoFactorAuth ( settings : TwoFactorAuthSettingsModel ) : Promise<any> {
    return this.workshopAPI.post('/sessions/submit_otp', settings, null, null)
    .then(( session : any ) => this.handleSession(session));
  }

  loginWithXero ( queryString : string ) : ng.IPromise<any> {
    return this.workshopAPI.get(`/sessions/xero${ queryString }`)
    .then(( session : any) => this.handleSession(session));
  }

  handleSession ( session : any, user : UserModel = { username: session.username } ) : ng.IPromise<any> {
    if ( session.two_factor_auth_required ) {
      this.sessionObjAPI.setKey('user', {
        id: session.user_id,
        ...user
      });

      this.$state.go('app.two-factor-auth-login');

      return;
    }

    return this.sessionObjAPI.handleSessionLogin(session, user)
    .catch(( error : HttpErrorResponse ) => {
      if ( error.status === this._STATUSCODES.paymentRequired ) {
        return this.subscriptionApi.reactivate(session);
      }

      return this.$q.reject(error);
    });
  }
}